(function () {

    "use strict";

    function SetPasswordController($translate, $http, $location, $stateParams, $mdToast, URL, $state) {

        var vm = this;

        vm.user = {
            username: "",
            password: ""
        };
        vm.loading = false;
        vm.errorMessage = "";
        vm.setPassword = setPassword;
        vm.login = function () {
            $state.go('/');
            $state.go('login');
        };
        function setPassword(form) {
            vm.errorMessage = "";
            if (form.password.$modelValue !== form.password2.$modelValue) {
                vm.errorMessage = $translate.instant("AUTH.PASSWORDSDONTMATCH");
                $mdToast.show($mdToast.simple().textContent(vm.errorMessage)
                    .position('top right').theme('error-toast').hideDelay(3000));
            }
            if (form.password.$modelValue.length < 6) {
                vm.errorMessage = $translate.instant("AUTH.PASSWORDNOTVALID");
                $mdToast.show($mdToast.simple().textContent(vm.errorMessage)
                    .position('top right').theme('error-toast').hideDelay(3000));
            }

            if (vm.errorMessage === "") {
                var data = {
                    email: vm.user.email,
                    newPassword: form.password.$modelValue,
                    token: $stateParams.token
                };
                $http({
                    method: "POST",
                    data: data,
                    cache: false,
                    url: URL.URL + "/api/setPassword"
                })
                    .then(function () {
                        vm.message = $translate.instant("AUTH.PASSWORDCHANGED");
                    })
                    .catch(function (error) {
                        vm.errorMessage = $translate.instant("AUTH.EMAILERROR" + error.status);
                        $mdToast.show($mdToast.simple().textContent(vm.errorMessage)
                            .position('top right').theme('error-toast').hideDelay(3000));
                    });
            }
        }

    }

    SetPasswordController.$inject = ["$translate", "$http", "$location", "$stateParams", "$mdToast", "URL","$state"];

    angular.module("sphForms.auth")
        .component("setPassword", {
            controller: SetPasswordController,
            templateUrl: "modules/auth/components/setPassword/setPassword.template.html"
        });

}());
